module.exports = __webpack_public_path__ + "img/fes-corn-wave.bb390fc1.svg";